import React from 'react';
import { Remote } from '@okapi/remote';

export const Header = () => <Remote widget="header-footer/header" id="planirovshchiki3d-header" />;
